// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { BehaviorSubject, Observable } from 'rxjs';

// --- HS Code
import { TeamEnquiryModel } from '../../../models/team/team-enquiry-model';
import { TeamEnquiryResult } from '../../../models/team/team-enquiry-result';
import { NumberOfEmployees } from '../../../models/team/number-of-employees';

// #endregion

@Injectable({
  providedIn: 'root'
})
export abstract class TeamEnquiryBaseService {

  protected _isSending$: BehaviorSubject<boolean>;
  get isSending$(): Observable<boolean> {
    return this._isSending$;
  }

  protected _isSent$: BehaviorSubject<boolean>;
  get isSent$(): Observable<boolean> {
    return this._isSent$;
  }

  protected _enquiryError$: BehaviorSubject<string>;
  get enquiryError$(): Observable<string> {
    return this._enquiryError$;
  }

  protected _enquiryResult$: BehaviorSubject<TeamEnquiryResult>;
  get enquiryResult$(): Observable<TeamEnquiryResult> {
    return this._enquiryResult$;
  }

  protected _numberOfEmployees$: BehaviorSubject<string[]>;
  get numberOfEmployees$(): Observable<string[]> {
    return this._numberOfEmployees$;
  }

  protected _shouldShowEnquiryForm$: BehaviorSubject<boolean>;
  get shouldShowEnquiryForm$(): Observable<boolean> {
    return this._shouldShowEnquiryForm$;
  }

  constructor() {
    this._isSending$ = new BehaviorSubject<boolean>(false);
    this._isSent$ = new BehaviorSubject<boolean>(false);
    this._enquiryError$ = new BehaviorSubject<string>(null);
    this._enquiryResult$ = new BehaviorSubject<string>(null);
    this._numberOfEmployees$ = new BehaviorSubject<string[]>(null);
    this._shouldShowEnquiryForm$ = new BehaviorSubject<boolean>(false);

    this.loadNumberOfEmployees();
  }


  abstract clearState(): void;
  abstract sendEnquiry(model: TeamEnquiryModel): void;
  loadNumberOfEmployees() {
    this._numberOfEmployees$.next(Object.keys(NumberOfEmployees).map((itm) => NumberOfEmployees[itm]));
  }

  showEnquiryForm(): void {
    this._shouldShowEnquiryForm$.next(true);
  }

  hideEnquiryForm(): void {
    this._shouldShowEnquiryForm$.next(false);
  }
}
